<div class="table-container">
  <div class="row content">
    <div class="cell col-a border-right">
      <div class="cell field" i18n>
        Totals
      </div>
    </div>
      <ng-container *ngIf="transactionType !== 'resi'; else resiTemplate">
        <div class="cell" fxLayout="row wrap" fxLayoutAlign="space-between">
          <div fxFlex="33%">
            <div class="cell field" fxFlex="80%">{{ +feeTotals?.total_transaction_amount | customCurrency:currency:'symbol-narrow' }}</div>
            <div class="cell symbol" fxFlex="20%"></div>
          </div>
          <div fxFlex="33%">
            <div class="cell field" fxFlex="80%"></div>
            <div class="cell symbol" fxFlex="20%"></div>
          </div>
          <div fxFlex="33%">
            <div class="cell field" fxFlex="80%">{{ +feeTotals?.total_cbre_amount | customCurrency:currency:'symbol-narrow' }}</div>
            <div class="cell symbol" fxFlex="20%"></div>
          </div>
        </div>
      </ng-container>
      <ng-template #resiTemplate>
        <div class="cell" fxLayout="row wrap" fxLayoutAlign="space-between">
          <div fxFlex="33%">
            <div class="cell field" fxFlex="80%"></div>
            <div class="cell symbol" fxFlex="20%"></div>
          </div>
          <div fxFlex="33%">
            <div class="cell field" fxFlex="80%"></div>
            <div class="cell symbol" fxFlex="20%"></div>
          </div>
          <div class="cell field" fxFlex="33%">{{ +feeTotals?.total_cbre_amount | customCurrency:currency:'symbol-narrow' }}</div>
        </div>
      </ng-template>
  </div>
</div>
